'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StyleService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../webComponents/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[StyleService]');

// Changing of user- or application-specific styles.

var StyleService = exports.StyleService = function () {
    function StyleService($rootScope, $window, context, userService, style) {
        var _this = this;

        _classCallCheck(this, StyleService);

        this.context = context;
        this.currentStyle = null;
        this.$window = $window;
        this.$rootScope = $rootScope;

        if (style) {
            // log('Setting style from winresCloud.style:', style);
            this.setStyle(style);
        } else {
            var user = userService.getCurrentUser();

            // log('User data:', user);

            if (user && user.getStyle()) {
                // log('Init user has style.', user.getStyle())
                this.setStyle(user.getStyle());
            }

            $rootScope.$on('userDataChanged', function (ev, user) {
                // log('User data changed:', user);
                if (user && user.getStyle()) {
                    // log('Setting style:', user.getStyle());
                    _this.setStyle(user.getStyle());
                }
            });
        }
    }

    _createClass(StyleService, [{
        key: 'setStyle',
        value: function setStyle(name) {
            // log("Style name:", name);

            if (this.currentStyle == name) {
                return;
            }

            if (this.mustReloadToSetStyle(name)) {
                // Need to reload page, since a style cannot be unset.
                // console.trace();
                log('Style changed from a custom style to another. Must reload page.', this.currentStyle, name);
                this.$window.location.reload();
                return;
            }

            var file = './' + name + '.sass';
            var fileNoPostCSS = './' + name + '.nopostcss.sass';
            // log('Style files are:', file, fileNoPostCSS);
            // log("context.keys():", this.context.keys());
            if (name && !_.includes(this.context.keys(), file) && !_.includes(this.context.keys(), fileNoPostCSS)) {
                log.error("Style file with name: ", name + ".sass not found. the existing files are :", this.context.keys());
                log('Nulling style.');
                this.setStyle(null);
                return;
            }

            this.currentStyle = name;

            if (name && _.includes(this.context.keys(), file)) {
                this.context(file);
            }
            if (name && _.includes(this.context.keys(), fileNoPostCSS)) {
                this.context(fileNoPostCSS);
            }
        }
    }, {
        key: 'mustReloadToSetStyle',
        value: function mustReloadToSetStyle(name) {
            return this.currentStyle && this.currentStyle !== name;
        }
    }]);

    return StyleService;
}();

StyleService.$inject = ['$rootScope', '$window'];

_module3.default.provider('styleService', function StyleServiceProvider() {
    var context = null;
    var style = null;
    this.setContext = function (ctx) {
        return context = ctx;
    };
    this.setStyle = function (stl) {
        return style = stl;
    };

    this.$get = ['$rootScope', '$window', 'userService', function ($rootScope, $window, userService) {
        return new StyleService($rootScope, $window, context, userService, style);
    }];
});


//////////////////
// WEBPACK FOOTER
// ./src/core/styleService.js
// module id = 32
// module chunks = 0 2